// extracted by mini-css-extract-plugin
module.exports = {"root":"SortAdornment_root__3TAfW","icon":"SortAdornment_icon__1dl8-","up":"SortAdornment_up__3p5ho","down":"SortAdornment_down__1v_tS","active":"SortAdornment_active__3L_xH"};